var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpensea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg-opensea",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 71,
    viewBox: "0 0 69 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.743,
    height: 36.649,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.472)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.472)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 35.5,
    rx: 34.5,
    ry: 35.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 35.5,
    rx: 33,
    ry: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.778 15.778)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.773,24.63l.132-.2,8.584-13.4a.291.291,0,0,1,.528.066c1.453,3.236,2.641,7.2,2.113,9.707a14,14,0,0,1-1.717,3.7,1.438,1.438,0,0,1-.33.528.343.343,0,0,1-.264.132H3.971a.365.365,0,0,1-.2-.528",
    transform: "translate(-1.263 -3.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.743,23.442v2.113c0,.132-.066.2-.2.264a10.139,10.139,0,0,0-3.9,2.641c-2.443,3.368-4.292,8.188-8.386,8.188H11.028A11.062,11.062,0,0,1,0,25.555v-.2a.284.284,0,0,1,.264-.264H9.971a.354.354,0,0,1,.33.33,3.677,3.677,0,0,0,.33,1.849,3.357,3.357,0,0,0,3.038,1.849h4.754v-3.7H13.735a.3.3,0,0,1-.264-.462.912.912,0,0,0,.2-.264c.462-.66,1.057-1.585,1.717-2.707a15.975,15.975,0,0,0,1.189-2.377,3.219,3.219,0,0,0,.2-.462c.066-.264.2-.528.264-.726l.2-.594a11.131,11.131,0,0,0,.2-2.179,4.678,4.678,0,0,0-.066-.924c0-.33-.066-.66-.066-.991a3.865,3.865,0,0,0-.132-.858,9.35,9.35,0,0,0-.264-1.321l-.066-.132a4.271,4.271,0,0,0-.264-.858,24.639,24.639,0,0,0-.924-2.641l-.4-.991c-.2-.462-.4-.924-.594-1.321-.066-.2-.2-.33-.264-.528s-.2-.4-.264-.594l-.2-.4-.594-1.057c-.066-.132.066-.33.2-.264l3.632.991.462.132.528.132.2.066V1.915A1.9,1.9,0,0,1,20.207,0a1.844,1.844,0,0,1,1.321.528,1.844,1.844,0,0,1,.528,1.321v3.17l.4.132a.065.065,0,0,1,.066.066,2.514,2.514,0,0,0,.4.33,2.872,2.872,0,0,0,.462.4c.33.264.792.66,1.255,1.057.132.132.264.2.33.33a26.126,26.126,0,0,1,1.915,1.915c.2.2.33.4.528.594s.33.462.528.66c.2.264.462.594.66.858a2.871,2.871,0,0,1,.264.462c.264.4.462.792.726,1.189.066.2.2.4.264.594a4.835,4.835,0,0,1,.528,1.651.718.718,0,0,1,.066.33,1.287,1.287,0,0,1,.066.528,7.481,7.481,0,0,1-.066,1.717c-.066.264-.132.462-.2.726a5.016,5.016,0,0,1-.264.726,13.973,13.973,0,0,1-.726,1.387,6.09,6.09,0,0,1-.33.528,2.317,2.317,0,0,0-.33.528c-.132.2-.33.4-.462.594a3.629,3.629,0,0,1-.462.594c-.2.264-.462.528-.66.792a3.051,3.051,0,0,1-.462.462,3.051,3.051,0,0,1-.462.462,4.272,4.272,0,0,1-.594.528l-.4.33a.243.243,0,0,1-.2.066H21.989v3.7h3.632a3.282,3.282,0,0,0,2.179-.792c.2-.2,1.123-.991,2.245-2.179.066-.066.066-.066.132-.066L40.215,23.31c.4-.2.528-.066.528.132",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpensea);
export default __webpack_public_path__ + "static/media/opensea.aaf0e2ba273c995a89e61564e3fbb203.svg";
export { ForwardRef as ReactComponent };